<template>
       <div class="container">
                <div class="page-header">
                    <div class="page-title">

                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li class="active">
                                  <router-link :title="'إدارة الاحداث'" :to="{name: 'events'}"> إدارة الاحداث</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-12 col-md-12 layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">
                                <div class="row">
                                  <div class="col-md-6">
                                        <h4>
                                            <i class="flaticon-computer-4"></i>
                                       إدارةالاحداث

                                        </h4>
                                          </div>
                                        <div class="col-md-6">
                                      <ul class="list-inline top-btns d-flex align-items-center m-0">
                                        <li class="list-inline-item">
                                      <create-button  v-if="hasPermissions('events_create')" :routeName="'events.create'"></create-button>
                                        </li>
                                        <li class="list-inline-item">
                                          <button class="search-btn-wg btn-creative btn-3 btn-3e flaticon-search-1
" v-if="searchingMode == 0" @click="searchingMode = 1"> <span>فلاتر البحث</span></button>
                                          <button class="btn btn-danger search-btn-wg mb-2 my-2 " v-if="searchingMode == 1" @click="searchingMode = 0">إغلاق X</button></li>
                                      </ul>

                                      </div>
                                    </div>
                                </div>

                            <div class="widget-content widget-content-area">
                                <form @submit.prevent="getIndexData(1)" v-if="searchingMode == 1" style="border: 1px solid #DDD;padding: 20px" class="mb-4">
                                    <div class="form-row">
                                        <div class="col-md-12 mt-2" v-if="user.role != 'teacher'">
                                          <label for="">الحلقة</label>
                                          <v-select v-model="lesson" :options="lessons" @search="onSearchLesson" />
                                        </div>
                                        <div class="col-md-6 mt-2">
                                          <label for="">من تاريخ </label>
                                          <date-picker v-model="data.searching.date_from" :editable="true" :calendar="'hijri'"></date-picker>
                                        </div>
                                        <div class="col-md-6 mt-2">
                                          <label for="">إلى تاريخ </label>
                                          <date-picker v-model="data.searching.date_to" :editable="true" :calendar="'hijri'"></date-picker>
                                        </div>
                                        <div class="col-md-4 mt-2">

                            <button type="submit" name="time" class="search-btn-wg btn-creative btn-3 btn-3e flaticon-search-1"> <span>بحث</span></button>
                                        </div>
                                    </div>
                                </form>
                                <div class="table-responsive">
                                  <div class="row mb-2">
                                      <div class="col-md-1">
                                        <span>إظهار</span>
                                        <select v-model="data.searching.perPage" @change="getIndexData(1)" class="form-control">
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                      </div>
                                    </div>
                                    <table class="table table-bordered mb-4">
                                        <thead>
                                            <tr>
                                                <th>
                                                  <a href="#" @click.prevent="resortData();">
                                                    <i class="flaticon-arrow-down-1" v-if="data.searching.sorting == 'asc'"></i>
                                                    <i class="flaticon-arrow-up" v-if="data.searching.sorting == 'desc'"></i>
                                                  </a>
                                                </th>
                                                <th @click="resortData();">التاريخ</th>
                                                <th @click="resortData();">اسم الحدث</th>
                                                <th @click="resortData();">الحلقة</th>
                                                <th class="align-center">#</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in data.data" :key="index">
                                                <td>{{index+1}}</td>
                                                <td>{{item.event_date}}</td>
                                                <td>{{item.name}}</td>
                                                <td>{{item.lesson ? item.lesson.name : '---'}}</td>
                                                <td class="text-center">

                                                    <div class="dropdown custom-dropdown">
                                                        <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                            <i class="flaticon-dot-three fs-17"></i>
                                                        </a>

                                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuLink1">
                                                            <edit-button v-if="hasPermissions('events_edit')" :routing="{name: 'events.edit', params: {id: item.id}}"></edit-button>

                                                            <delete-button v-if="hasPermissions('events_delete')" :deleteUrl="'/events/' + item.id" :data="item" @deleteData="deleteData"></delete-button>
                                                        </div>
                                                    </div>

                                                </td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                              <th>
                                                  <a href="#" @click.prevent="resortData();">
                                                    <i class="flaticon-arrow-down-1" v-if="data.searching.sorting == 'asc'"></i>
                                                    <i class="flaticon-arrow-up" v-if="data.searching.sorting == 'desc'"></i>
                                                  </a>
                                                </th>
                                                <th @click="resortData();">التاريخ</th>
                                                <th @click="resortData();">اسم الحدث</th>
                                                <th @click="resortData();">الحلقة</th>
                                                <th class="align-center">#</th>
                                            </tr>
                                        </tfoot>

                                    </table>
                                </div>
                                <div class="row">
                                  <div class="col-md-4">
                                    <simple-pagination :data="data.paginated" @getIndexData="getIndexData($event)"></simple-pagination>
                                  </div>
                                  <div class="col-md-8 mt-4">
                                    <table-info v-if="Object.keys(data.paginated).length" :data="data.paginated"></table-info>
                                  </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>


            </div>


</template>
<script>
import 'vue-select/dist/vue-select.css';
import VueDatetimeJs from 'vue-datetime-js'

export default {
  components: {
    datePicker: VueDatetimeJs,
  },
  data() {
    return {
      printData: {
      },
      data: {
        data: {},
        searching:{
            id: '',
            lesson_id: '',
            name: '',
            date_from: '',
            date_to: '',
            perPage: 10,
            sorting: 'desc'
        },
        paginated: {},
        showFilter: false,
      },
       options: [],
       lessons: [],
       groups: [],
       searchingMode: 0,
       stage: {},
       group: {},
    };
  },
  created(){
      this.search(null, '', this, 'lesson');
      this.getIndexData(1);
  },
  methods: {
    resortData(){
        this.data.searching.sorting = this.data.searching.sorting == 'asc' ? 'desc' : 'asc';
        this.getIndexData(1);
    },
    print(data){
      this.printData = data;
        this.$baseApi.get('/events/' + data.id).then((response)=>{
            if(response.data.code == 200){
              this.printData = response.data.data.activity;
              setTimeout(() => {
                this.print_element('printMe', 'نشاط');


              }, 2000);

            }else{
                alert(response.data.error.error);
            }
        });
    },
    onSearchLesson(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this, 'lesson');
      }
    },
    search(loading, w, vm, type){
      this.$baseApi.get('/events?pluck=1&search='+w+'&pluckType='+type).then((response)=>{
        if(loading){
          loading(false);
        }
            if(response.data.code == 200){
              if(type == 'lesson'){
                this.lessons = response.data.data.options;
              }
            }else{
                alert(response.data.error.error);
            }
        });
    },
      getIndexData(page){
        this.$baseApi.get('/events?page=' + page, {
                    params: this.data.searching
                }).then((response)=>{
            if(response.data.code == 200){
               this.data.paginated = response.data.data.events;
               this.data.data = response.data.data.events.data;

            }else{
                alert(response.data.error.error);
            }
        });
      },
      deleteData(data){
          this.data.data.splice(this.data.data.indexOf(data), 1);
      },
    clearFilter(items) {
      this.data.showFilter = !this.data.showFilter
      if (!this.data.showFilter) {
        for (const itemsKey in items) {
          this.data.searching[itemsKey] = ''
        }
        this.getIndexData(1);
      }
    }
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    }
  },
   watch: {
    // Note: only simple paths. Expressions are not supported.
    stage(newValue) {
      this.data.searching.stage_id = newValue.id;
    }
  }
};
</script>
<style>
</style>
